import React,{ useState, useEffect, useRef }  from 'react';
import {Header,Container,Segment,Button}  from 'semantic-ui-react'
import Sign from './Sign'
import useWebsocket from './Hooks/useWebsocket'
import Show from './ShowTransaktion'
import {Switch,Route,useHistory} from "react-router-dom";






const App = () => {

    const history=useHistory()
    const ws=useRef()
    const [msgData,setMsgData]=useState({})
    const [connected,setConnected]=useState(false)

    const handleWs=(data)=>
    {
        if(data.__type==='sign')
        {
            setMsgData(data)
            history.push('/sign')
        }
        if(data.__type==='show')
        {
            setMsgData(data)
            history.push('/show/'+data.UID)
        }
        if(data.__type==='close')
            history.push('/')
    }

   useWebsocket(ws,handleWs,['sign','close','show'],setConnected)


    return (
        <>
           <Button 
                circular icon={connected ? 'check' :'delete'} 
                color={connected ? 'green' :'red'} 
                style={{'margin-left':'auto', 'margin-right':0, display: 'block'}} 
                onClick={(e)=>{window.location.href='https://'+window.location.hostname}}
            />
           <Container>
                
                <Switch>
                    <Route exact path="/sign">
                        <Sign ws={ws} msgData={msgData}/>
                    </Route>
                    <Route exact path="/show/:UID">
                        <Show />
                    </Route>
                    <Route exact path="/">
                        
                            <Segment style={{marginTop:'300px'}}>
                                <Header as="h1" style={{textAlign:'center'}}>Danke</Header>
                                <Header as="h2" style={{textAlign:'center'}}>Bis zum nächsten mal</Header>
                            </Segment>
                    
                    </Route>
                </Switch>
            </Container>
        </>
    )
}


export default App;
